import axios from "axios";
import TokenService from "./tokenService";
import AuthService from "./authService";
import {
  RedireccionUrlContraseniaIdentidad,
  RedireccionUrlIdentidad,
  cambiarUrl,
  keyAccess,
} from "../utils/helpers/helpers";
import {
  CLAIM_COD_CONT,
  CLAIM_TOKEN_SESION_C,
} from "../utils/helpers/roleHelpers";
import { error } from "console";

let type = { "Content-type": "application/json" };

//IPERC Digital Produccion
let administracionUrl = "https://web18-e1.api.lasbambas.com/api/v1/";
let identidadUrl = "https://web32-e1.api.lasbambas.com/api/";
let ipercUrlBase = "https://web14-e1.api.lasbambas.com/api/v1/";
let listVerificacionUrl = "https://web13-e1.api.lasbambas.com/api/v1/";
let dispositivoUrl = "https://web20-e1.api.lasbambas.com/api/v1/";
let urlBaseIdentidad = "https://iperc-mina.lasbambas.com/identidad";
let gestionDocumentosUrl = "https://mmg-bso-dev-web60-e1.azurewebsites.net/api/v1/";
let urlLogin = "https://iperc-mina.lasbambas.com/login";
let urlTelerik = "https://mmg-bso-dev-web33-e1.azurewebsites.net/api";

export let urlRecuperarContraseniaIdentidad = `${urlBaseIdentidad}/recuperarContraseniaEmail/${cambiarUrl(
  urlLogin
)}`;

const siteKey = "6LciwikpAAAAAMUgfs2GRNGyJzzHCbkJff3N7ImR";
const clientId = "f0649dd0-4f56-4da1-ae0f-52686fe23ab7";

export const homepageLogin = "Login";

const fetchIdentidad = axios.create({
  baseURL: identidadUrl,
  headers: type,
});

const fetchGestionDocumentos = axios.create({
  baseURL: gestionDocumentosUrl,
  headers: type,
});

const fetchIPERC = axios.create({
  baseURL: ipercUrlBase,
  headers: type,
});

const fetchIPERCFirma = axios.create({
  baseURL: ipercUrlBase,
  headers: type,
});

const fetchListVerificacion = axios.create({
  baseURL: listVerificacionUrl,
  headers: type,
});

const fetchAdministracion = axios.create({
  baseURL: administracionUrl,
  headers: type,
});

const fetchDispositivo = axios.create({
  baseURL: dispositivoUrl,
  headers: type,
});

const fetchUrlTelerik = axios.create({
  baseURL: urlTelerik,
  headers: type,
});

//Interceptor Token

fetchIdentidad.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchIdentidad.interceptors.response.use(
  (response) => {
    let t = TokenService.getToken();
    if (t) {
      const decodedToken = AuthService.getInfoToken(CLAIM_COD_CONT);
      const decodedTokenSec = AuthService.getInfoToken(CLAIM_TOKEN_SESION_C);
      if (decodedToken === "01") {
        //alert("Primer inicio de sesión: Debe cambiar su contraseña.")
        alert("Por favor, cambie su contraseña para continuar");
        //let infoUrl = `http:@dominio!login/cambiarContrasenia/${decodedToken}/${t}/http:@:dominio!login`
        //let urlLogin = "http://dominio/login";
        var urlLogFinal = cambiarUrl(urlLogin);
        let email = "";
        const userDataString = localStorage.getItem("Access");
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          const userEmail = userData.email;
          email = userEmail;
        } else {
          alert("No fue posible obtener el email");
        }

        window.location.assign(
          RedireccionUrlIdentidad(
            urlBaseIdentidad,
            email,
            decodedTokenSec,
            urlLogFinal
          )
        );
      }
      if (decodedToken === "02") {
        alert("Contraseña expirada, debe actualizar su contraseña.");
        var urlLogFinal = cambiarUrl(urlLogin);
        let email = "";
        const userDataString = localStorage.getItem("Access");
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          const userEmail = userData.email;
          email = userEmail;
        } else {
          alert("No fue posible obtener el email");
        }

        //limpiar storage
        //localStorage.clear();

        window.location.assign(
          RedireccionUrlContraseniaIdentidad(
            urlBaseIdentidad,
            email,
            decodedTokenSec,
            urlLogFinal
          )
        );
      }
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
      //alert("Sesión expirada...");
    } else if (error && error.response) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

fetchAdministracion.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchAdministracion.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

fetchListVerificacion.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    alert(error);
    return Promise.reject(error);
  }
);

fetchListVerificacion.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

fetchIPERC.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);
fetchIPERC.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

fetchDispositivo.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    alert(error);
    return Promise.reject(error);
  }
);

fetchDispositivo.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

fetchUrlTelerik.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchUrlTelerik.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

fetchGestionDocumentos.interceptors.request.use(
  (config) => {
    if (config.headers) {
      let isExp = AuthService.verifiedExp();
      if (isExp) {
        localStorage.removeItem(keyAccess);
        AuthService.removeToken();
      }
      let t = TokenService.getToken();
      if (t == null) {
        localStorage.removeItem(keyAccess);
      }
      config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
  },
  (error) => {
    //alert(error);
    return Promise.reject(error);
  }
);

fetchGestionDocumentos.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(keyAccess);
      AuthService.removeToken();
      window.location.assign("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

export {
  fetchIdentidad,
  fetchIPERC,
  fetchListVerificacion,
  fetchAdministracion,
  fetchDispositivo,
  /* Teseo */
  urlTelerik,
  /* -- */
  fetchIPERCFirma,
  fetchUrlTelerik,
  fetchGestionDocumentos,
  urlLogin,
  siteKey,
  clientId,
};
